const actions = {
    REGISTER_SERVICE_REQUEST: "REGISTER_SERVICE_REQUEST",
    REGISTER_SERVICE_SUCCESS: "REGISTER_SERVICE_SUCCESS",
    REGISTER_SERVICE_FAILURE: "REGISTER_SERVICE_FAILURE",
  
    LOGIN_SERVICE_REQUEST: "LOGIN_SERVICE_REQUEST",
    LOGIN_SERVICE_SUCCESS: "LOGIN_SERVICE_SUCCESS",
    LOGIN_SERVICE_FAILURE: "LOGIN_SERVICE_FAILURE",
  
    POST_OTP_SERVICE_REQUEST: "POST_OTP_SERVICE_REQUEST",
    POST_OTP_SERVICE_SUCCESS: "POST_OTP_SERVICE_SUCCESS",
    POST_OTP_SERVICE_FAILURE: "POST_OTP_SERVICE_FAILURE",
  
    GET_AGGREMENT_SERVICE_REQUEST: "GET_AGGREMENT_SERVICE_REQUEST",
    GET_AGGREMENT_SERVICE_SUCCESS: "GET_AGGREMENT_SERVICE_SUCCESS",
    GET_AGGREMENT_SERVICE_FAILURE: "GET_AGGREMENT_SERVICE_FAILURE",
  
    ACCEPT_AGGREMENT_SERVICE_REQUEST: "ACCEPT_AGGREMENT_SERVICE_REQUEST",
    ACCEPT_AGGREMENT_SERVICE_SUCCESS: "ACCEPT_AGGREMENT_SERVICE_SUCCESS",
    ACCEPT_AGGREMENT_SERVICE_FAILURE: "ACCEPT_AGGREMENT_SERVICE_FAILURE",
  
    CREATE_OTP_SERVICE_REQUEST: "CREATE_OTP_SERVICE_REQUEST",
    CREATE_OTP_SERVICE_SUCCESS: "CREATE_OTP_SERVICE_SUCCESS",
    CREATE_OTP_SERVICE_FAILURE: "CREATE_OTP_SERVICE_FAILURE",
  
    CLOSE_MODAL: "CLOSE_MODAL",
  
    RESET_AGREEMENT: "RESET_AGREEMENT",
    RESET_OTP_RESPONSE: "RESET_OTP_RESPONSE",
    RESET_ERROR: "RESET_ERROR",
    GET_USER_BY_ID_REQUEST: "GET_USER_BY_ID_REQUEST",
    GET_USER_BY_ID_SUCCESS: "GET_USER_BY_ID_SUCCESS",
    GET_USER_BY_ID_FAILURE: "GET_USER_BY_ID_FAILURE",
  };
  
  export default actions;